import axios from 'axios';

export const state = {
  emoneyUsers: [],
  emoneyUsersPagination: {},
  walletEscrows: [],
  userEscrows: [],
  isCallingRestartKYc: [],
  loading: false,
  lockedUsers: [],
  errorOnUserUpdated: null,
  selectedEmoneyUser: {},
};

export const mutations = {
  setEmoneyUsers(context, emoneyUsers) {
    context.emoneyUsers = emoneyUsers;
    context.loading = false;
  },

  setLockedUser(context, lockedUsers) {
    context.lockedUsers = lockedUsers;
    context.loading = false;
  },

  setEmoneyUsersPagination(context, pagination) {
    context.emoneyUsersPagination = pagination;
    context.loading = false;
  },

  setWalletEscrows(context, walletEscrows) {
    context.walletEscrows = walletEscrows;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },

  startCallRestartKYC(context, userId) {
    context.isCallingRestartKYc.push(userId);
  },

  stopCallRestartKYC(context, userId) {
    const index = context.isCallingRestartKYc.indexOf(userId);

    if (index > -1) {
      context.isCallingRestartKYc.splice(index, 1);
    }

    context.loading = false;
  },
  setEmoneySelectedUser(context, emoneyUser) {
    context.selectedEmoneyUser = emoneyUser;
    context.loading = false;
  },
  setErrorOnEmoneyUserUpdated(context, error) {
    context.errorOnAssetUpdated = error;
    context.loading = false;
  },
};

export const getters = {
  emoneySelectedUser: currentState => currentState.selectedEmoneyUser,
  emoneyErrorOnUserUpdated: currentState => currentState.errorOnUserUpdated,
};

export const actions = {
  async getEmoneyUsers({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const emoneyUsers = await axios.get(`${window.BASE_API.EMONEY}/admin/users?${query}`, options)
        .then(response => response.data);

      commit('setEmoneyUsers', emoneyUsers.data);
      commit('setEmoneyUsersPagination', emoneyUsers.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async getLockedUsers({ commit, rootState }) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const lockedUsers = await axios.get(`${window.BASE_API.EMONEY}/admin/users?${query}`, options)
        .then(response => response.data);

      commit('setLockedUsers', lockedUsers);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async getWalletEscrows({ commit, rootState }, walletId) {
    try {
      commit('setWalletEscrows', []);
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const walletEscrows = await axios.get(`${window.BASE_API.EMONEY}/wallet/${walletId}/escrows`, options)
        .then(response => response.data);

      commit('setWalletEscrows', walletEscrows);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async resetUserKYC({ commit, rootState }, userId) {
    try {
      commit('setLoading', true);
      commit('startCallRestartKYC', userId);
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      await axios.post(`${window.BASE_API.EMONEY}/admin/user/${userId}/kyc-document`, null, options)
        .then(response => response.data);

      commit('stopCallRestartKYC', userId);
      commit('setLoading', false);
    } catch (err) {
      commit('stopCallRestartKYC', userId);
      commit('setLoading', false);
    }
  },

  async setEmoneySelectedUser({ commit }, user) {
    commit('setEmoneySelectedUser', user);
  },

  async lockUser({ commit, dispatch, rootState }, data) {
    try {
      commit('setLoading', true);
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      await axios.post(`${window.BASE_API.EMONEY}/admin/user/${data.userId}/locked`, { locked: data.locked }, options)
        .then(response => response.data);

      dispatch('getEmoneyUsers');
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async updateEmoneyUser({ commit, dispatch, rootState }, payload) {
    commit('setErrorOnEmoneyUserUpdated', null);
    const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
    const options = {
      headers: {
        Authorization: jwtToken,
      },
    };
    const url = `${window.BASE_API.EMONEY}/admin/users/${state.selectedEmoneyUser.ext_user_id}`;
    try {
      const updatedEmoneyUser = await axios.patch(url, {
        mangopay_user_id: payload.mangopay_user_id,
        mangopay_wallet_id: payload.mangopay_wallet_id,
        wallet_iban: payload.wallet_iban,
        wallet_bic: payload.wallet_bic,
      }, options);
      commit('setEmoneyUsers', [updatedEmoneyUser.data]);
      commit('setLoading', false);
    } catch (error) {
      console.error(error.message);
      commit('setLoading', false);
      commit('setErrorOnEmoneyUserUpdated', error.message);
      throw error;
    }
  },
};

const emoneyUsersStore = {
  state,
  mutations,
  getters,
  actions,
};

export default emoneyUsersStore;



// WEBPACK FOOTER //
// ./src/store/emoneyUsers/emoneyUsersStore.js